import { render } from "./HelpDesk.vue?vue&type=template&id=1489ed3a&scoped=true"
import script from "./HelpDesk.vue?vue&type=script&lang=js"
export * from "./HelpDesk.vue?vue&type=script&lang=js"

import "./HelpDesk.vue?vue&type=style&index=0&id=1489ed3a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1489ed3a"]])

export default __exports__